import Reveal from "./Reveal";

export default function CalendarSection() {
    return (
        <section className="relative overflow-hidden px-5 py-20 sm:py-28" data-testid="calendar-section">
            <span className="chapter-num absolute -top-4 right-2 text-[9rem] sm:text-[13rem]" aria-hidden="true">
                03
            </span>
            <div className="relative mx-auto max-w-4xl">
                <Reveal className="text-center">
                    <div className="mb-4 flex items-center justify-center gap-2">
                        <span className="dot-blink h-1.5 w-1.5 rounded-full bg-[#ef4444]" />
                        <span className="text-xs font-medium uppercase tracking-[0.2em] text-[#ff7a30]">Último paso</span>
                    </div>
                    <h2 className="font-display text-3xl font-extrabold leading-[1.08] sm:text-5xl">
                        Elige tu <em className="serif-accent text-grad">horario</em>
                    </h2>
                    <p className="mx-auto mt-4 max-w-md text-sm text-[#999] sm:text-base">
                        20 minutos por Google Meet · Gratuita · Sin compromiso
                    </p>
                </Reveal>

                <Reveal delay={150} className="mt-10">
                    <div id="calendar" className="scroll-mt-24 rounded-3xl border border-[#222] bg-[#111111] p-2 sm:p-3">
                        <div className="overflow-hidden rounded-2xl bg-white">
                            <iframe
                                src="https://api.leadconnectorhq.com/widget/booking/i9C9tRjp7n3rN7eNdOGr"
                                style={{ width: "100%", border: "none", height: "82vh", minHeight: "600px" }}
                                scrolling="auto"
                                title="Agenda tu consultoría"
                                data-testid="calendar-iframe"
                            />
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
